import { DragDropContext } from '@hello-pangea/dnd'
import { Box, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'
import DetailsLoading from '../Loading/DetailsLoading'
import DealsKanbanHeader from './DealsKanbanHeader'
import KanbanColumn from './KanBanColumn'
import { StickyHeader } from './style'
import './styles.css'

const Root = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  height: 'calc(100vh - 182px)', // Adjust based on your header and footer height
  // width: 'calc(100vw - 60px)',
  width: '100vw',
  padding: '16px',
  // overflowY: 'hidden', // Prevent scrolling of the entire page
})

const DealsKanban = ({
  kanbanData,
  stageTotals,
  extraStages,
  setExtraStages,
  totalSum,
  totalGrossProfit,
  totalDeals,
  activePipeline,
  weightedPipeline,
  dealWonRevenue,
  onDragEnd,
  isLoading,
}) => {
  const { pinned } = useLayoutContext()

  // console.log('dealsKanbanRendered')
  // const theme = useTheme()
  // const { pinned } = useLayoutContext()
  // const queryClient = useQueryClient()
  // // const { pipelineDeals, isPipelineLoading, isPipelineError } = usePipelineDeals(true, ['pipeline', 'deals'])
  // const { organizations, deals: pipelineDeals } = useEntitiesFromSearch()
  // const { users, isUsersLoading, isUsersError } = useUsers(true, ['users'])
  // const stablePipelineDeals = useMemo(() => pipelineDeals || [], [pipelineDeals])
  // const stableUsers = useMemo(() => users || [], [users])
  // const stableOrganizations = useMemo(() => organizations || [], [organizations])

  // const [kanbanTotals, setKanbanTotals] = useState({})
  // const [stageTotals, setStageTotals] = useState({})
  // const [extraStages, setExtraStages] = useState(false)
  // const [totalSum, setTotalSum] = useState(0)
  // const [isDragging, setIsDragging] = useState(false)

  // const [totalGrossProfit, setTotalGrossProfit] = useState(0)
  // const [totalDeals, setTotalDeals] = useState(0)
  // const [localStageState, setLocalStageState] = useState({})
  // const [kanbanData, setKanbanData] = useState({})
  // const refinedDeals = useMemo(() => updateDealStages(pipelineDeals), [pipelineDeals])
  // useEffect(() => {
  //   if (kanbanData) {
  //     setKanbanTotals(prev => ({
  //       ...prev,
  //       openDeals: calculatePipelineMetrics(kanbanData).openDealsCount,
  //       activePipelineIncome: calculatePipelineMetrics(kanbanData).activePipelineIncome,
  //       weightedPipeline: calculateWeightedPipeline(kanbanData),
  //       dealWonRevenue: calculateDealWonRevenue(kanbanData),
  //     }))
  //   }
  // }, [kanbanData])
  // // useEffect(() => {
  // //   if (!isDragging && pipelineDeals && !isUsersLoading) {
  // //     const stages = loadDealsIntoKanban(refinedDeals, extraStages, users, organizations)
  // //     const totals = aggregateStageTotals(stages)
  // //     setStageTotals(totals)
  // //     setLocalStageState(totals)
  // //     setKanbanData(stages) // ✅ Ensure this does not update while dragging
  // //   }
  // // }, [pipelineDeals, extraStages, users, organizations, isDragging])
  // useEffect(() => {
  //   if (!isDragging && stablePipelineDeals.length > 0 && !isUsersLoading) {
  //     const stages = loadDealsIntoKanban(refinedDeals, extraStages, stableUsers, stableOrganizations)
  //     const totals = aggregateStageTotals(stages)
  //     setStageTotals(totals)
  //     setLocalStageState(totals)
  //     setKanbanData(stages)
  //   }
  // }, [refinedDeals, extraStages, stableUsers, stableOrganizations, isDragging])

  // const { mutate: updateItem } = useUpdateItem()
  // const { showSnackbar } = useSnackbarContext()

  // const handleDroppedUpdate = (fieldName, itemId, newValue) => {
  //   updateItem(
  //     {
  //       primaryKey: 'deal_uuid',
  //       tableName: 'deals',
  //       itemId,
  //       fieldName,
  //       newValue,
  //     },
  //     {
  //       onSuccess: () => {
  //         showSnackbar(`Deal ${fieldName} updated successfully`, 'success')
  //         queryClient.invalidateQueries({ queryKey: ['deal', itemId] })
  //         console.log('Update successful')
  //       },
  //       onError: err => {
  //         console.error('Update failed', err)
  //       },
  //     }
  //   )
  // }

  // const onDragEnd = result => {
  //   const { source, destination } = result
  //   if (!destination || (source.droppableId === destination.droppableId && source.index === destination.index)) return

  //   handleDroppedUpdate('stage', result.draggableId, destination.droppableId)

  //   // setKanbanData(prevData => {
  //   //   const newData = { ...prevData }

  //   //   const sourceColumn = [...newData[source.droppableId].items]
  //   //   const destinationColumn = [...newData[destination.droppableId].items]

  //   //   const [movedItem] = sourceColumn.splice(source.index, 1)
  //   //   destinationColumn.splice(destination.index, 0, movedItem)

  //   //   return {
  //   //     ...newData,
  //   //     [source.droppableId]: { ...newData[source.droppableId], items: sourceColumn },
  //   //     [destination.droppableId]: { ...newData[destination.droppableId], items: destinationColumn },
  //   //   }
  //   // })
  //   setKanbanData(prevData => {
  //     if (source.droppableId === destination.droppableId && source.index === destination.index) {
  //       return prevData
  //     }

  //     const newData = { ...prevData }
  //     const sourceColumn = [...newData[source.droppableId].items]
  //     const destinationColumn = [...newData[destination.droppableId].items]

  //     const [movedItem] = sourceColumn.splice(source.index, 1)
  //     destinationColumn.splice(destination.index, 0, movedItem)

  //     return {
  //       ...newData,
  //       [source.droppableId]: { ...newData[source.droppableId], items: sourceColumn },
  //       [destination.droppableId]: { ...newData[destination.droppableId], items: destinationColumn },
  //     }
  //   })
  // }

  // const StickyHeader = styled(Box)(({ theme }) => ({
  //   position: 'sticky',
  //   top: 0,
  //   zIndex: 2,
  //   backgroundColor: theme.palette.background.paper,
  //   boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  //   padding: '16px',
  //   borderBottom: `1px solid ${theme.palette.divider}`,
  // }))
  // const testLoading = true
  // const isLoading = isUsersLoading
  const MemoizedKanbanColumn = React.memo(KanbanColumn)

  return (
    <>
      {isLoading ? (
        <DetailsLoading />
      ) : (
        <Stack className="deals-kanban-container" sx={{ height: pinned ? 'calc(100vh - 60px)' : '100vh' }}>
          {/* Sticky Header */}
          <StickyHeader>
            <DealsKanbanHeader
              extraStages={extraStages}
              setExtraStages={setExtraStages}
              // totalSum={totalSum}
              // totalGrossProfit={totalGrossProfit}
              totalDeals={totalDeals}
              activePipeline={activePipeline}
              weightedPipeline={weightedPipeline}
              dealWonRevenue={dealWonRevenue}
              isLoading={isLoading}
            />
          </StickyHeader>
          {/* Scrollable Kanban Columns */}
          <DragDropContext onDragEnd={onDragEnd}>
            <Box
              sx={{
                flex: 1,
                // overflowX: 'auto', // Horizontal scrolling for columns
                // overflowY: 'hidden', // Prevent vertical scrolling here
                display: 'flex',
              }}
            >
              <Root>
                {Object.keys(kanbanData).map(key => {
                  return (
                    <MemoizedKanbanColumn
                      key={key}
                      columnId={key}
                      items={kanbanData[key].items}
                      label={kanbanData[key].label}
                      total={stageTotals[key]?.total}
                      grossProfit={stageTotals[key]?.grossProfit}
                    />
                  )
                })}
              </Root>
            </Box>
          </DragDropContext>
        </Stack>
      )}
    </>
  )
}

export default DealsKanban
